import axios from 'axios';
import { API_HOST } from '../../api_utils';

export const GenerateLicense = async (payload, token) => {
  const config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  };

  const response = await axios.post(`${API_HOST}license/createLicense`, payload, config);
  return response.data;
};

export const getListLicenses = async (org_id, token, onlyUnassigned = false) => {
  const url = onlyUnassigned
    ? `${API_HOST}license/?organizationId=${org_id}&onlyUnassigned=true`
    : `${API_HOST}license/?organizationId=${org_id}`;
  const response = await axios.get(
    url,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  );
  return response.data;
};

